// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TokenStandard } from './TokenStandard';
import {
    TokenStandardFromJSON,
    TokenStandardFromJSONTyped,
    TokenStandardToJSON,
} from './TokenStandard';

/**
 * 
 * @export
 * @interface TokenTransfer
 */
export interface TokenTransfer {
    /**
     * 
     * @type {string}
     * @memberof TokenTransfer
     */
    fromUserAccount: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenTransfer
     */
    toUserAccount: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenTransfer
     */
    fromTokenAccount: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenTransfer
     */
    toTokenAccount: string | null;
    /**
     * 
     * @type {number}
     * @memberof TokenTransfer
     */
    tokenAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TokenTransfer
     */
    decimals: number;
    /**
     * 
     * @type {TokenStandard}
     * @memberof TokenTransfer
     */
    tokenStandard: TokenStandard;
    /**
     * 
     * @type {string}
     * @memberof TokenTransfer
     */
    mint: string;
}

/**
 * Check if a given object implements the TokenTransfer interface.
 */
export function instanceOfTokenTransfer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fromUserAccount" in value;
    isInstance = isInstance && "toUserAccount" in value;
    isInstance = isInstance && "fromTokenAccount" in value;
    isInstance = isInstance && "toTokenAccount" in value;
    isInstance = isInstance && "tokenAmount" in value;
    isInstance = isInstance && "decimals" in value;
    isInstance = isInstance && "tokenStandard" in value;
    isInstance = isInstance && "mint" in value;

    return isInstance;
}

export function TokenTransferFromJSON(json: any): TokenTransfer {
    return TokenTransferFromJSONTyped(json, false);
}

export function TokenTransferFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenTransfer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromUserAccount': json['fromUserAccount'],
        'toUserAccount': json['toUserAccount'],
        'fromTokenAccount': json['fromTokenAccount'],
        'toTokenAccount': json['toTokenAccount'],
        'tokenAmount': json['tokenAmount'],
        'decimals': json['decimals'],
        'tokenStandard': TokenStandardFromJSON(json['tokenStandard']),
        'mint': json['mint'],
    };
}

export function TokenTransferToJSON(value?: TokenTransfer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromUserAccount': value.fromUserAccount,
        'toUserAccount': value.toUserAccount,
        'fromTokenAccount': value.fromTokenAccount,
        'toTokenAccount': value.toTokenAccount,
        'tokenAmount': value.tokenAmount,
        'decimals': value.decimals,
        'tokenStandard': TokenStandardToJSON(value.tokenStandard),
        'mint': value.mint,
    };
}

